import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page72() {
  useEffect(() => {
    document.title = "Маяк — Страница 71"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page70" />
        <ForwardLink href="/page72" />
      </div>

      <p style={{ textAlign: "right" }}>71.</p>
      <p>на части!</p>
      <p>
        Они приближаются друг к другу, у них заканчиваются предметы,<br/>
        которые можно бросить. Воющий смех...
      </p>
      <br/>
      <p>-ГОСТИНАЯ. ПОЗЖЕ</p>
      <p>
        СТАРИК вытаскивает еще одну бутылку и бросает ее перед<br/>
        МОЛОДЫМ.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Пей.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Да, да, сэр.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Одним глотком.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Ты сделаешь это.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        ЧЕРТОВО ВРАНЬЕ! Правило гласит:<br/>
        делай, как я говорю! Любое слово, кроме<br/>
        “есть” — бунт!
      </p>
      <p>Пауза.</p>
      <p>
        МОЛОДОЙ выдергивает пробку. Он пьет и пьет, ликер<br/>
        льется по сторонам его щетинистого лица.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК (ПРОДОЛЖЕНИЕ)<br/>
        Что за парень!!
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Есть, есть, ЕСТЬ, ЕСТЬ! ЕСТЬ!<br/>
        ЕЕЕЕЕСТЬ!!!!!!
      </p>
      <p>– ПОЗЖЕ</p>
      <p>ОБА выливают выпивку себе на лицо.</p>
      <p>ГРЕМИТ ГРОМ. МОЛНИЯ МЕЛЬКАЕТ В ОКНЕ.</p>
      <br/>
      <p>– ПОЗЖЕ</p>
      <p>
        МОЛОДОЙ настолько пьян, что в это трудно поверить. Он пропитан<br/>
        ликером.
      </p>
      <p>
        Голова СТАРИКА лежит на плече МОЛОДОГО. Он приходит в сознание<br/>
        и снова теряет его.
      </p>
      <p style={{ textAlign: "right" }}>71.</p>

      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page70" />
        <ForwardLink href="/page72" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710633791/the-lighthouse-script/y4ma1bdpmy0gshjsna4y.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page72;
